<template>
  <div>
    <div @click="isOpen = !isOpen">
      <slot name="trigger" :isOpen="isOpen"></slot>
    </div>

    <div v-if="isOpen">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps } from "vue";

const props = defineProps({
  defaultOpen: {
    type: Boolean,
    default: false,
  },
});

const isOpen = ref(props.defaultOpen);
</script>
